import React from 'react';
import ReactDOM from 'react-dom/client';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./Assets/Styles/global.scss";
import "./Assets/Styles/responsive.scss";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './Context/AuthProvider';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import 'primeicons/primeicons.css';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { EventType, PublicClientApplication } from '@azure/msal-browser';
// import "primereact/resources/themes/nova-light/theme.css";
// import "primereact/resources/primereact.min.css";
// import "primeicons/primeicons.css";

const msalInstance:any = new PublicClientApplication(msalConfig);
msalInstance.initialize();
// if(!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length>0){
//   msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
// }
// msalInstance.addEventCallback((event:any)=>{
//   if(event.eventType === EventType.LOGIN_SUCCESS && event.payload.account){
//     const account = event.payload.account;
//     msalInstance.setActiveAccount(account);
//   }
// })

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </MsalProvider>
  // </React.StrictMode>
);
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js").then(
          (registration) => {
              console.log("Service Worker registered with scope:", registration.scope);
          },
          (error) => {
              console.log("Service Worker registration failed:", error);
          }
      );
  });
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
